const style = {
  cancelCall: {
    background: "#F07939",
    '&:hover': {
      background: "#F07939",
    }
  },
  recievingLoader: {
    color: '#ccc'
  }
};

export default style;